import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const blockSliderReviews = () => {
	initSliders('.block-slider-reviews .slider-content .swiper');
};

export default blockSliderReviews;
